// extracted by mini-css-extract-plugin
export default {"mCard":"kC-z","image":"lC-z","imageNoBackground":"mC-z","imageHasCategory":"nC-z","fullWidth":"oC-z"};